import React from "react";
import NavPart from "./NavBar";
import '../Assets/Styles/HomePage.scss'
import Home from "./Home";
import About from "./About";
import Footer from "./Footer";
import Contact from "./Contact";
import Skills from "./Skills";
import Projects from "./Projects";


const HomePage = () => {
  return (
    <div>
      <NavPart />
      <Home />
      <About />
      <Skills />
      <Projects  />

      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
